import * as _ from 'lodash';

import {SectionConfig, Sections} from '../../client/app/shared/components/manage-column/manage-column.model';
import {Shift} from '../../client/app/timecard/models/timecard-entry.view.model';
import {CommonPunchTypes, ForceCallEnum, MealPenaltyEnum, SagPunchTypes, WorkConditionEnum} from '../../common/timecard.enum';
import {SagDetail} from '../../common/timecard.shifts.model';


export const PunchTimesSequenceOrder = [
  SagPunchTypes.leaveForLocation,
  SagPunchTypes.arriveOnLocation,
  SagPunchTypes.makeupWardrobeIn,
  SagPunchTypes.onSet,
  SagPunchTypes.dismiss,
  SagPunchTypes.makeupWardrobeOut,
  SagPunchTypes.leaveLocation,
  SagPunchTypes.arriveStudio
];

export const MealsTimeSequenceOrder = [
  CommonPunchTypes.ndb1In,
  CommonPunchTypes.ndb1Out,
  CommonPunchTypes.meal1Out,
  CommonPunchTypes.meal1In,
  CommonPunchTypes.meal2Out,
  CommonPunchTypes.meal2In
];

export const SagSpecificValidationFields: string[] = [..._.values(SagPunchTypes),  'workStatuses', 'stuntAdjustment', 'notPhotographed'];
export const SagTravelAllowanceCompatibleWorkStatus = ['FT', 'TR', 'H', 'HD', 'HOL', 'PUFT', 'PUH', 'PUR', 'R', 'SR'];
export const SickWorkStatusCompatiblePayTypes = ['GUAR_FULL', 'GUAR_HALF', 'NOPAY', 'SICK4', 'SICK8'];
export const SagPunchIncompatibleWorkStatus = ['H', 'HD', 'HF', 'I', 'PUH', 'SH', 'SHD', 'SHF', 'SICK'];
export const SagStartTimes = [SagPunchTypes.makeupWardrobeIn, SagPunchTypes.onSet, SagPunchTypes.leaveForLocation];
export const SagEndTimes = [SagPunchTypes.makeupWardrobeOut, SagPunchTypes.dismiss, SagPunchTypes.arriveStudio];

export namespace SagTimecardDetailConstants {
  export class TimecardEntry {
    public static get SagCommonPunchColumnConfigs(): SectionConfig {
      return {
        isShowAllColumns: false,
        groupName: 'Time',
        section: Sections.commonPunch,
        columns: {
          workStatus: {field: 'workStatus', header: 'Work Status', isVisible: true, isMandatory: false, ordinal: 1},
          mkpOrWrdIn: {field: 'mkpOrWrdIn', header: 'Mk/Wd In', isVisible: true, isMandatory: false, ordinal: 2},
          onSet: {field: 'onSet', header: 'On Set', isVisible: true, isMandatory: false, ordinal: 3},
          dismiss: {field: 'dismiss', header: 'Dismiss', isVisible: true, isMandatory: false, ordinal: 4},
          mkpOrWrdOut: {field: 'mkpOrWrdOut', header: 'Mk/Wd Out', isVisible: true, isMandatory: false, ordinal: 5},
          ndb1In: {field: 'ndb1In', header: 'NDB In', isVisible: true, isMandatory: false, ordinal: 6},
          ndb1Out: {field: 'ndb1Out', header: 'NDB Out', isVisible: true, isMandatory: false, ordinal: 7},
          meal1Out: {field: 'meal1Out', header: 'M1 Start', isVisible: true, isMandatory: false, ordinal: 8},
          meal1In: {field: 'meal1In', header: 'M1 Finish', isVisible: true, isMandatory: false, ordinal: 9},
          meal2Out: {field: 'meal2Out', header: 'M2 Start', isVisible: true, isMandatory: false, ordinal: 10},
          meal2In: {field: 'meal2In', header: 'M2 Finish', isVisible: true, isMandatory: false, ordinal: 11},
          leaveForLoc: {field: 'leaveForLoc', header: 'Leave for Loc', isVisible: true, isMandatory: false, ordinal: 12},
          arriveOnLoc: {field: 'arriveOnLoc', header: 'Arr on Loc', isVisible: true, isMandatory: false, ordinal: 13},
          leaveLoc: {field: 'leaveLoc', header: 'Leave Loc', isVisible: true, isMandatory: false, ordinal: 14},
          arriveStudio: {field: 'arriveStudio', header: 'Arr Studio', isVisible: true, isMandatory: false, ordinal: 15},
          stuntAdj: {field: 'stuntAdj', header: 'Stunt Adj', isVisible: true, isMandatory: false, ordinal: 16}
        }
      };
    }

    public static get SagAccountCodingColumnConfigs(): SectionConfig {
      return {
        isShowAllColumns: false,
        groupName: 'Coding',
        section: Sections.accountCoding,
        columns: {
          glShortcut: {field: 'glShortcut', header: 'GL SHORTCUTS', isVisible: false, isMandatory: false, ordinal: 2}
        }
      };
    }

    public static get SagReRateColumnConfigs(): SectionConfig {
      return {
        isShowAllColumns: false,
        groupName: 'Rerate',
        section: Sections.reRate,
        columns: {
          jobCode: {field: 'jobCode', header: 'Code', isVisible: false, isMandatory: false, ordinal: 1},
          scheduleCode: {field: 'scheduleCode', header: 'Sched', isVisible: false, isMandatory: false, ordinal: 2},
          rerateAmount: {field: 'rerateAmount', header: 'Rate', isVisible: true, isMandatory: false, ordinal: 3}
        }
      };
    }

    public static get SagShiftDetailsColumnConfigs(): SectionConfig {
      return {
        isShowAllColumns: false,
        groupName: 'Details',
        section: Sections.details,
        columns: {
          mealPenalty1: {field: 'mealPenalty1', header: 'MP1', isVisible: true, isMandatory: false, ordinal: 1},
          mealPenalty2: {field: 'mealPenalty2', header: 'MP2', isVisible: true, isMandatory: false, ordinal: 2},
          forceCall: {field: 'forceCall', header: 'FC', isVisible: false, isMandatory: false, ordinal: 3},
          nightPremium: {field: 'nightPremium', header: 'NP', isVisible: false, isMandatory: false, ordinal: 4},
          notPhotog: {field: 'notPhotog', header: 'Not Photog', isVisible: false, isMandatory: false, ordinal: 5},
          workCondition: {field: 'workCondition', header: 'Condition', isVisible: true, isMandatory: false, ordinal: 6},
          payType: {field: 'payType', header: 'Pay Type', isVisible: true, isMandatory: false, ordinal: 7},
          dayType2: {field: 'dayType2', header: 'Day Type', isVisible: true, isMandatory: false, ordinal: 8},
          stateCode: {field: 'stateCode', header: 'State', isVisible: false, isMandatory: false, ordinal: 9},
          countyCode: {field: 'countyCode', header: 'County', isVisible: false, isMandatory: false, ordinal: 10},
          cityCode: {field: 'cityCode', header: 'City', isVisible: false, isMandatory: false, ordinal: 11},
          countryCode: {field: 'countryCode', header: 'Country', isVisible: false, isMandatory: false, ordinal: 12},
          locFinder: {field: 'locFinder', header: 'Loc Finder', isVisible: false, isMandatory: false, ordinal: 13}
        }
      };
    }

    public static get SagBreakageColumnConfig(): SectionConfig {
      return {
        isShowAllColumns: false,
        groupName: 'Breakage',
        section: Sections.breakages,
        columns: {
          hoursWorked: {field: 'hoursWorked', header: 'Wrk Hrs', isVisible: true, isMandatory: false, ordinal: 1},
          hoursPaid: {field: 'hoursPaid', header: 'Paid Hrs', isVisible: true, isMandatory: false, ordinal: 2},
          MP1Count: {field: 'MP1Count', header: 'MPV1#', isVisible: false, isMandatory: false, ordinal: 3},
          MP1Amount: {field: 'MP1Amount', header: '$', isVisible: false, isMandatory: false, ordinal: 4},
          MP2Count: {field: 'MP2Count', header: 'MPV2#', isVisible: false, isMandatory: false, ordinal: 5},
          MP2Amount: {field: 'MP2Amount', header: '$', isVisible: false, isMandatory: false, ordinal: 6},
          totalAmount: {field: 'totalAmount', header: 'Amount', isVisible: true, isMandatory: false, ordinal: 7}
        }
      };
    }

    public static get SagInitialDefaultShift(): Shift {
      return {
        shiftId: '',
        shiftDate: {
          shiftId: '',
          date: ''
        },
        shiftRate: {
          shiftId: '',
          jobCode: {value: ''},
          scheduleCode: {value: ''},
          rerateAmount: {value: 0}
        },
        workDetail: <SagDetail> {
          shiftId: '',
          notPhotographed: false,
          workCondition: {value: WorkConditionEnum.Studio},
          mealPenalty1: MealPenaltyEnum.Yes,
          mealPenalty2: MealPenaltyEnum.Yes,
          forceCall: ForceCallEnum.Yes,
          nightPremium: true,
          countryCode: {value: ''},
          stateCode: {value: ''},
          countyCode: {value: ''},
          cityCode: {value: ''},
          payType: {value: ''},
          dayType2: {value: ''}
        },
        accountCode: {
          shiftId: '',
          glShortcutId: '',
          segments: []
        },
        payPunch: {
          shiftId: ''
        },
        prPunch: {
          shiftId: ''
        },
        mobilePunch: {
          shiftId: ''
        },
        workStatus: {
          shiftId: '',
          workStatuses: {value: []}
        }
      };
    }
  }
}
